import React, { useState, useContext, useEffect } from "react";
import $ from "jquery";
import PsContext from "../../../context";
import { Tab, Tabs } from "react-bootstrap";

const TabMenu = (props) => {
  const context = useContext(PsContext);

  const [selectedTab, setSelectedTab] = useState(props.tabKey || "");

  useEffect(() => {
    if (props.tabKey) {
      setSelectedTab(props.tabKey);
    }
  }, [props.tabKey]);

  const handleTabChange = (key) => {
    setSelectedTab(key);
    if (props.onTabChange) props.onTabChange(key);
  };

  const maxCourseSelection = () =>
    selectedTab == "regular"
      ? context.settingValue("admission_ug_regular_max_course_selection")
      : context.settingValue("admission_ug_self_max_course_selection");

  return (
    <div className="course-selection-wrapper my-4">
      {maxCourseSelection() > 1 && (
        <div className="info-box-dark shadow-lg mb-4">
          <div
            className="info-icon-circle"
            style={{ background: "rgba(255,165,0,0.1)", color: "#ffa500" }}
          >
            <i className="fa-solid fa-circle-exclamation"></i>
          </div>
          <div className="flex-grow-1">
            <span className="fs-12 fw-800 text-white opacity-50 text-uppercase tracking-wider">
              SELECTION GUIDELINE
            </span>
            <div className="fs-14 fw-bold text-white mt-1">
              You can select a Maximum of{" "}
              <span className="text-info px-1">{maxCourseSelection()}</span>{" "}
              programmes on a single application.
            </div>
          </div>
        </div>
      )}

      <div className="course-tabs-dark-wrap shadow-xl">
        {context.settingValue("admission_has_ug_regular") == "1" && (
          <button
            type="button"
            className={`course-tab-dark-btn border-0 ${
              selectedTab === "regular" ? "active" : ""
            }`}
            onClick={() => handleTabChange("regular")}
          >
            Click here to Apply for Aided Programme asdasdasd
          </button>
        )}

        {context.settingValue("admission_has_ug_self") == "1" && (
          <button
            type="button"
            className={`course-tab-dark-btn border-0 ${
              selectedTab === "self" ? "active" : ""
            }`}
            onClick={() => handleTabChange("self")}
          >
            Click here to Apply for Unaided Programme
          </button>
        )}
      </div>
    </div>
  );
};

export default TabMenu;
